var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-resize-adjust",
    class: ['frame-margin'],
    staticStyle: {
      "background-color": "white",
      "position": "relative"
    },
    attrs: {
      "id": "frame"
    }
  }, [(_vm.readingDocument) ? _c('div', {
    staticClass: "document-btn-container"
  }, [_c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.docLeftArrow',
        visible: true
      },
      "exec": _vm.backward,
      "icon": _vm.$root.icons.left,
      "btnClasses": "btn-primary",
      "styleObj": {
        'margin': '1px 0px 2px 6px',
        'padding': '3px 7px 5px 7px',
        'position': 'relative',
        'top': '4px',
        'border-radius': '3px',
        'height': '28px'
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "margin": "0px 4px 0px 4px",
      "padding": "0px 4px 3px 3px",
      "position": "relative",
      "top": "4px",
      "border-radius": "3px",
      "width": "50px"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.reading.np
    },
    domProps: {
      "value": _vm.readingPage
    },
    on: {
      "change": _vm.submitPager
    }
  }), _vm._v(" "), _c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.docRightArrow',
        visible: true
      },
      "exec": _vm.forward,
      "icon": _vm.$root.icons.right,
      "btnClasses": "btn-primary",
      "styleObj": {
        'margin': '1px 0px 2px 0px',
        'padding': '3px 7px 5px 7px',
        'position': 'relative',
        'top': '4px',
        'border-radius': '3px',
        'height': '28px'
      }
    }
  }), _vm._v(" "), _c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.docClose',
        visible: true
      },
      "exec": _vm.loadContent,
      "icon": _vm.$root.icons.close,
      "btnClasses": "btn-primary",
      "styleObj": {
        'margin': '1px 0px 2px 4px',
        'padding': '3px 7px 5px 7px',
        'position': 'relative',
        'top': '4px',
        'border-radius': '3px',
        'height': '28px'
      }
    }
  }), _vm._v(" "), _c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.docDownload',
        visible: true
      },
      "exec": _vm.downloadContent,
      "icon": _vm.$root.icons.download,
      "btnClasses": "btn-primary",
      "styleObj": {
        'margin': '1px 0px 2px 4px',
        'padding': '3px 7px 5px 7px',
        'position': 'relative',
        'top': '4px',
        'border-radius': '3px',
        'height': '28px'
      }
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "sk-cube-grid",
    staticStyle: {
      "height": "20px",
      "width": "20px",
      "z-index": "9999",
      "margin-top": "-21px",
      "margin-left": "58px"
    }
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.readingNoChildrenNode) ? _c('div', {
    staticClass: "document-btn-container"
  }, [_c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.docClose',
        visible: true
      },
      "exec": _vm.loadContent,
      "icon": _vm.$root.icons.close,
      "btnClasses": "btn-primary",
      "styleObj": {
        'margin': '1px 0px 2px 4px',
        'padding': '3px 7px 5px 7px',
        'position': 'relative',
        'top': '5px',
        'left': '4px',
        'border-radius': '3px',
        'height': '28px'
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "block",
      "height": "100%",
      "text-align": "center"
    },
    attrs: {
      "id": "viewer_wrapper"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c7773c2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub-views/ViewerContainer.vue
// module id = 1649
// module chunks = 1